module.exports = {
  "country": "LV",
  "artist": "Marie N",
  "song": "I Wanna",
  "year": "2002",
  "place": "1",
  "spotify": "70tFqMdkFXCPeirRaLAKKM"
};